import { useCallback } from "react"
import { CustomMutationParams, useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { chConfirmDuplicatePatientsMutation } from "@/modules/patients/manage-duplicates/services/ch/chConfirmDuplicatePatientsMutation"
import { deConfirmDuplicatePatientsMutation } from "@/modules/patients/manage-duplicates/services/de/deConfirmDuplicatePatientsMutation"
import { Country } from "@/types/__generated__/union-types"

type ConfirmDuplicatePatientsInput = {
  primaryPatientId: string
  duplicatePatientIds: string[]
  undoDuplicatePatientIds: string[]
  reason: string
}

const useConfirmDuplicatePatientsMutation = (country: Country, params?: CustomMutationParams) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chConfirmDuplicatePatientsMutation
      case "DE":
        return deConfirmDuplicatePatientsMutation
    }
  })()

  const [commit, isInFlight] = useMutationWithErrorToast(mutation, params)

  const commitHandler = useCallback(
    (input: ConfirmDuplicatePatientsInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted,
      })
    },
    [commit],
  )

  return [commitHandler, isInFlight] as const
}

export { useConfirmDuplicatePatientsMutation }
